import { messageError } from '../../components/message';
import { SUPPORT_ACCOUNT_POSTFIX } from '../../config/user';
import { withAPIAccount } from '../../lib/http/api';
import { APIError, parsedResponse } from '../../lib/http/http';
import { AccountType, IAPIresponse, RoleGroupType } from '../../model';
import {
  IAPIStudioMemberHasPermissionItem,
  IAPIStudioMemberItem,
} from '../../model/api-modules';
import { API_PREFIX, STUDIO_PREFIX } from '../config';

// 工作室-成员列表-不包括权限
export const getStudioMembers = (studioId: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${STUDIO_PREFIX}/${studioId}/members`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<Array<IAPIStudioMemberItem>>(
        response,
        'data'
      );
      return res;
    } catch (error) {
      if (error instanceof APIError) {
        messageError(error.message);
      }
      return null;
    }
  });

// 工作室-成员列表-包括权限
export const getStudioMembersHasPermission = (studioId: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${STUDIO_PREFIX}/${studioId}/members-roles`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<
        Array<IAPIStudioMemberHasPermissionItem>
      >(response, 'data');
      return res.filter(
        (item) => !item.UserID.endsWith(SUPPORT_ACCOUNT_POSTFIX)
      );
    } catch (error) {
      if (error instanceof APIError) {
        messageError(error.message);
      }
      return null;
    }
  });

// 工作室-移除成员
export const removeMember = (studioId: string, uid: Array<string>) =>
  withAPIAccount(AccountType.auto, async (api): Promise<IAPIresponse> => {
    try {
      const url = `${STUDIO_PREFIX}/${studioId}/members/remove`;
      const response = await api.commonRequest('DELETE', url, { uid });
      const res = await parsedResponse<IAPIresponse>(response, 'data');
      return res;
    } catch (error) {
      console.log('failed: removeMember', error);
      return {};
    }
  });

// 转移 owner 权限
export const transferMember = (uid: string, studioID: string) =>
  withAPIAccount(AccountType.auto, async (api): Promise<boolean> => {
    try {
      const url = `${API_PREFIX}/studio/${studioID}/members/transfer`;
      const response = await api.commonRequest('PUT', url, {
        uid,
        // studioID,
      });
      const res = await parsedResponse<IAPIresponse>(response, 'data');
      if (res && res.code === 0) {
        return true;
      }
      return false;
    } catch (error) {
      console.log('failed: transferMember', error);
      return false;
    }
  });

// 设置用户为admin
export const postUserAsAdmin = (
  userIds: ReadonlyArray<string>,
  studioID: string
) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${API_PREFIX}/user/permission/set-admin`;
      const response = await api.commonRequest('POST', url, {
        userIds,
        studioID,
      });
      return await parsedResponse<IAPIresponse>(response, 'data');
    } catch (error) {
      console.log('failed: postUserAsAdmin', error);
      return false;
    }
  });

// 管理员邀请成员
export const inviteMember = (
  studioId: string,
  uid: ReadonlyArray<string>,
  userUrl: string,
  authType: RoleGroupType,
  authID: Array<number>
) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${STUDIO_PREFIX}/${studioId}/members/invite`;
      const response = await api.commonRequest('POST', url, {
        uid,
        url: userUrl,
        authType,
        authID,
      });
      const res = await parsedResponse<IAPIresponse>(response, 'all');
      return res;
    } catch (error) {
      console.log('failed: inviteMember', error);
      throw error;
    }
  });

// 管理员编辑成员
export const editMember = (
  studioID: string,
  uid: Array<string>,
  userUrl: string,
  authType: RoleGroupType,
  authID: Array<number>
) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${STUDIO_PREFIX}/${studioID}/members/edit`;
      const response = await api.commonRequest('PUT', url, {
        uid,
        url: userUrl,
        authType,
        authID,
      });
      const res = await parsedResponse<IAPIresponse>(response, 'data');
      return res;
    } catch (error) {
      console.log('failed: editMember', error);
      throw error;
    }
  });

// 工作室-检查邀请链接是否有效
export const getCheckInviteLink = (key: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${STUDIO_PREFIX}/members/check-invite-link`;
      const response = await api.commonRequest('GET', url, { key });
      return await parsedResponse<IAPIresponse>(response, 'data');
    } catch (error) {
      console.log('failed: checkInviteLink', error);
      return false;
    }
  });

// 通过邮件 key 加入工作室
export const postMailJoinTeam = (key: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${STUDIO_PREFIX}/members/mail-join?key=${key}`;
      const response = await api.commonRequest('POST', url);
      return await parsedResponse<IAPIresponse>(response, 'data');
    } catch (error) {
      console.log('failed: mailJoins', error);
      return false;
    }
  });
